module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Remerciements")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.00em"
    }
  }, [_vm._v("MERCI")]), _vm._v(" à Poppy Dennison de m’avoir convaincue et d’avoir été aussi enchantée que je l’étais de revisiter mon ancienne bibliothèque de collections de romances des années quatre-vingt, qui m’ont servi d’inspiration pour ce roman. Merci aussi à la Brooklyn Public Library d’avoir autant de Collection Azur dans son catalogue. Et un remerciement particulier à Damon Suede, qui m’a aidée pour le titre avant même que ce livre n’ait d’intrigue.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cb2de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0